const translations = {
    help: 'Help'
};

export default translations;
